import { JxtTagColorsEnum } from '@jooxter/utils';
import { JxtHomeAgendaItemKindEnum } from './types';

export const agendaBarClasses: Record<JxtHomeAgendaItemKindEnum, string> = {
  [JxtHomeAgendaItemKindEnum.Meeting]: 'bg-primary-100',
  [JxtHomeAgendaItemKindEnum.Space]: 'bg-green-100',
};

export const agendaTagClasses: Record<JxtTagColorsEnum, string> = {
  [JxtTagColorsEnum.BLUE]: 'bg-primary-10 text-primary-140',
  [JxtTagColorsEnum.GREEN]: 'bg-green-10 text-green-140',
  [JxtTagColorsEnum.ORANGE]: 'bg-orange-10 text-orange-140',
  [JxtTagColorsEnum.RED]: 'bg-red-10 text-red-140',
  [JxtTagColorsEnum.NEUTRAL]: 'bg-neutral-10 text-neutral-140',
};
